import { EMAIL_CONTACT_POINT_SYSTEM, PHONE_CONTACT_POINT_SYSTEM } from "utils"

import type { OnboardingPersonFormType, PersonInformation, PersonResource, PutPersonRequest } from "./types"

const getInitialOnboardingState = (
  practiceIdentifier: string,
  practitioner = "",
  identifier = "",
): OnboardingPersonFormType => ({
  identifier,
  practiceIdentifier,
  firstName: "",
  lastName: "",
  gender: "male",
  birthdate: "",
  emails: [{ value: "", system: EMAIL_CONTACT_POINT_SYSTEM, use: "home" }],
  phones: [{ value: "", system: PHONE_CONTACT_POINT_SYSTEM, use: "home" }],
  practitioner,
  termsAccepted: false,
})

const emptyToNull = (value: string | undefined | null): string | null => {
  if (value == null || value.trim() === "") return null
  return value
}

const toFormBirthdate = (dateOfBirth: string | null) => {
  if (!dateOfBirth) return ""
  return dateOfBirth.split("T")[0] ?? dateOfBirth
}

const personToFormValues = (
  person: PersonInformation,
  current: OnboardingPersonFormType,
): OnboardingPersonFormType => ({
  ...current,
  identifier: person.identifier ?? "",
  practiceIdentifier: person.practiceIdentifier,
  firstName: person.firstName ?? "",
  lastName: person.lastName ?? "",
  gender: person.gender ?? current.gender,
  birthdate: toFormBirthdate(person.dateOfBirth),
  practitioner: person.practitionerIdentifier ?? current.practitioner,
  emails: [{ value: person.email ?? "", system: EMAIL_CONTACT_POINT_SYSTEM, use: "home" }],
  phones: [{ value: person.phone ?? "", system: PHONE_CONTACT_POINT_SYSTEM, use: "home" }],
})

const formValuesToPerson = (values: OnboardingPersonFormType): PersonResource => ({
  identifier: emptyToNull(values.identifier),
  practiceIdentifier: values.practiceIdentifier,
  practitionerIdentifier: emptyToNull(values.practitioner),
  email: emptyToNull(values.emails[0]?.value),
  firstName: emptyToNull(values.firstName),
  lastName: emptyToNull(values.lastName),
  dateOfBirth: emptyToNull(values.birthdate),
  gender: emptyToNull(values.gender),
  phone: emptyToNull(values.phones[0]?.value),
})

const formValuesToPutPersonRequest = (values: OnboardingPersonFormType, transient: boolean): PutPersonRequest => ({
  patientInformation: formValuesToPerson(values),
  transient,
})

export { getInitialOnboardingState, personToFormValues, formValuesToPerson, formValuesToPutPersonRequest }
